module.exports = __webpack_public_path__ + "static/media/bg-desk-spiral-3.8126818f.svg";